import { Modal } from 'src/components/molecules';
import {
  UpdateCaseManagerText,
  UpdateCaseManagerBoldText,
} from './ReassignCaseModal.styles';

interface ReassignCaseModalProps {
  open: boolean;
  setOpen(open: boolean): void;
  onConfirm(): void;
  onCancel(): void;
  isConfirmButtonDisabled?: boolean;
}

export const ReassignCaseModal = ({
  open,
  setOpen,
  onConfirm,
  onCancel,
  isConfirmButtonDisabled,
}: ReassignCaseModalProps) => (
  <Modal
    title={'Confirm Case Reassignment'}
    setOpen={setOpen}
    open={open}
    onConfirm={onConfirm}
    onCancel={onCancel}
    isConfirmButtonDisabled={isConfirmButtonDisabled}
    size={'medium'}
    data-testid={'case-reassignment-modal'}
  >
    <UpdateCaseManagerText>
      Are you sure you want to reassign the case lead for this case?
    </UpdateCaseManagerText>
    <br />
    <UpdateCaseManagerText>
      By confirming, you are acknowledging that you understand the following:
    </UpdateCaseManagerText>
    <br />

    <UpdateCaseManagerText>
      1.{' '}
      <UpdateCaseManagerBoldText>
        Responsibility Transfer:
      </UpdateCaseManagerBoldText>{' '}
      The responsibility for managing and overseeing this case will be
      transferred to the new case lead.
    </UpdateCaseManagerText>

    <UpdateCaseManagerText>
      2. <UpdateCaseManagerBoldText>Communication:</UpdateCaseManagerBoldText>{' '}
      The new case lead and the reporter will be notified of this reassignment
      via email and within the system.
    </UpdateCaseManagerText>

    <UpdateCaseManagerText>
      3. <UpdateCaseManagerBoldText>Access:</UpdateCaseManagerBoldText> The new
      case lead will have access to all case-related information and data.
    </UpdateCaseManagerText>
  </Modal>
);
